<template>
  <div>
    <div class="hero hero-cover hero-gradient">
      <div class="container">
        <h1 class="text-white text-center" v-scroll-reveal>Kontakt</h1>
      </div>
    </div>

    <div class="section bg-gray-100 text-secondary">
      <div class="container" v-scroll-reveal>
        <div class="flex flex-wrap text-center sm:text-left">
          <div class="w-full sm:w-1/3 mb-6 sm:mb-0">
            <span class="block w-1/2 sm:w-40 h-px mx-auto sm:mx-0 bg-gray-200"></span>
            <span class="block text-xl text-secondary font-bold my-3 sm:my-6">Adresa</span>
            <div class="flex flex-col font-light">
              <span class="font-semibold">Uprava: </span>
              <span>Koledovčina 1d</span>
              <span>HR - 10 000 Zagreb</span>
            </div>
            <div class="flex flex-col font-light mt-6">
              <span class="font-semibold">Skladište:</span>
              <span>Koledovčina 1</span>
              <span>HR - 10 000 Zagreb</span>
            </div>
          </div>
          <div class="w-full sm:w-1/3 mb-6 sm:mb-0">
            <span class="block w-1/2 sm:w-40 h-px mx-auto sm:mx-0 bg-gray-200"></span>
            <span class="block text-xl text-secondary font-bold my-3 sm:my-6">Kontakt broj</span>
            <div class="flex flex-col font-light">
              <div>
                <span class="font-bold">T</span>
                <a href="tel:+38514343900" class="text-secondary hover:text-primary">+385 1 4343 900</a>
              </div>
              <div>
                <span class="font-bold">F</span>
                <a href="tel:+38514343999" class="text-secondary hover:text-primary">+385 1 4343 999</a>
              </div>
            </div>
          </div>
          <div class="w-full sm:w-1/3">
            <span class="block w-1/2 sm:w-40 h-px mx-auto sm:mx-0 bg-gray-200"></span>
            <span class="block text-xl text-secondary font-bold my-3 sm:my-6">Kontakt mail</span>
            <div class="flex flex-col font-light">
              <a
                href="mailto:supranet@supranet.hr"
                class="text-secondary hover:text-primary"
              >supranet@supranet.hr</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section bg-white text-secondary text-center">
      <div class="container" v-scroll-reveal>
        <h3>Supra Net d.o.o.</h3>
        <span class="block w-1/2 sm:w-40 h-px bg-gray-200 mx-auto my-6 lg:my-12"></span>
        <div class="flex flex-col font-light">
          <span>Koledovčina 1d, Zagreb 10 000, Hrvatska</span>
          <span>OIB: 43340124580 - MB: 1812351 - MBS: 080484807</span>
          <span>IBAN: HR2024840081102219137</span>
        </div>
      </div>
    </div>

    <div class="section pt-0">
      <div id="map" class="bg-primary-light h-48 md:h-96 xxl:h-128 fdh:h-152" v-scroll-reveal>
        <GmapMap :center="mapPosition1" :zoom="14" class="h-full">
          <GmapMarker :position="mapPosition1"></GmapMarker>
          <!-- <GmapMarker :position="mapPosition2"></GmapMarker> -->
        </GmapMap>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mapPosition1:{
          full_name: 'Koledovčina 1d',
          lat: 45.79508,
          lng: 16.03965,
      },

       mapPosition2:{
          full_name: 'Koledovčina 5',
          lat: 45.796370,
          lng: 16.039981
      },
    };
  },

  metaInfo: {
    title: "Kontakt",
    meta: [
      {
        vmid: "og:image",
        property: "og:image",
        content: "https://www.supranet.hr/img/contact/Kontakt.jpg"
      }
    ]
  }
};
</script>
